import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useGetPriceRemarkParametersAuditQuery } from "@/services/price-remark/parameters";
import { PriceRemarkAuditEntry } from "@/services/price-remark/types";

function describe(entry: PriceRemarkAuditEntry): string {
  if (!entry.parametro) return "Alteração";
  return `${entry.parametro}: ${entry.valorAnterior ?? "—"} → ${entry.valorNovo ?? "—"}`;
}

export function ParametersAuditPanel() {
  const { data, isLoading } = useGetPriceRemarkParametersAuditQuery({
    limit: 20,
  });
  const entries = data?.data ?? [];

  return (
    <Card className="h-fit w-full">
      <CardHeader>
        <CardTitle className="text-base">Histórico de auditoria</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {isLoading && <p className="text-sm text-gray-500">Carregando…</p>}
        {!isLoading && entries.length === 0 && (
          <p className="text-sm text-gray-500">
            Nenhuma alteração registrada ainda.
          </p>
        )}
        {entries.map((entry) => (
          <div key={entry.id} className="border-b pb-2 text-sm last:border-0">
            <p className="font-medium text-gray-800">{describe(entry)}</p>
            <p className="text-xs text-gray-500">
              {entry.usuario ?? "—"} ·{" "}
              {entry.data ? new Date(entry.data).toLocaleString("pt-BR") : "—"}
            </p>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}

export default ParametersAuditPanel;
